export {IF_PARTNER_MATCH};

import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';

import {ctxAmateur} from '../../amateurPool/context/amateur.js';
import {createConditional as Conditional} from 'nova'

/**
 * Show the partner's match status.
 *
 * Remove the element from the document while the {@link ctxAmateur | partner} is no match.
 *
 * @example
 *
 * ```html
 * <img if-partner-match src="icon/match.svg" />
 * ```
 *
 * @group DOM Attribute
 */
const IF_PARTNER_MATCH = 'if-partner-match';

AttributeSetup(IF_PARTNER_MATCH, (name) => {
  const watch = Watch(attributeSelector(name), ctxAmateur);

  AttributeLink(name, (element) => {
    const toggle = Conditional(element);

    return (element) => watch(element, (element, partner) => toggle(!!partner?.isMatch()));
  });
});
